export const increaseBet = (
  pouseauto: any,
  win: string,
  stake: string,
  baseStake: string,
  onLoss: boolean,
  onLossPercent: string,
  onWin: boolean,
  onWinPercent: string,
  precision: number,
  handleStake: any,
) => {
  const localWin = Number(win)
  const localStake = Number(stake)
  const localWinPercent = Number(onWinPercent)
  let newStake = baseStake
  if (!pouseauto) {
    if (localWin > 0) {
      if (!onWin) {
        newStake = baseStake
      } else
        newStake = (
          +localStake +
          (+localStake * +localWinPercent) / 100
        ).toFixed(precision)
    }
    if (localWin < 0) {
      if (!onLoss) {
        newStake = baseStake
      } else {
        newStake = (+stake + (+stake * +onLossPercent) / 100).toFixed(precision)
      }
    }
  }
  handleStake(newStake)
  return newStake
}
